import { render } from "./HotelList.vue?vue&type=template&id=0fb16f31"
import script from "./HotelList.vue?vue&type=script&lang=js"
export * from "./HotelList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__